export default __webpack_public_path__ + "static/media/cn_bass_amp_pic.17842c46.webp";